onReady(($) => {
    const pricingTables = $('.pricing-table-column');
    if (pricingTables.length === 0) {
        return
    }

    // Replace or add UTMs on CTAs
    const utmQueryString = getUTMParameters()
    if (utmQueryString) {
        $('.block  a.cta-button', pricingTables)
            .each((i, link) => replaceLinkParameters(link, utmQueryString))
        $('.popup  a.cta-button')
            .each((i, link) => replaceLinkParameters(link, utmQueryString))
    }

    $('.featuresList  p.heading')
        .on("click ", function () {
            if ($(window)
                .width() <= 991) {
                $(this)
                    .next()
                    .slideToggle();
                $(this)
                    .toggleClass('open');
            }
        });
    $('.featureItem.info .icon')
        .on("click", function () {
            if ($(window)
                .width() <= 991) {
                $(this)
                    .parent()
                    .toggleClass('showtool');
                $(this)
                    .siblings('.text')
                    .toggleClass('none');
            }
        });
});
